import {
  InfiniteListBase,
  useListContext,
  useTranslate,
  useRedirect,
} from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { MobileListHeader } from "../../layout/MobileListHeader";
import { MobileContent } from "../../layout/MobileContent";
import { InfinitePagination } from "../../misc/InfinitePagination";
import { AccountBalanceBadge } from "./AccountBalanceBadge";
import type { Account } from "../../types";

export const MobileAccountList = () => (
  <InfiniteListBase
    perPage={50}
    sort={{ field: "name", order: "ASC" }}
    filter={{ "archived_at@is": null }}
  >
    <MobileAccountListLayout />
  </InfiniteListBase>
);

const MobileAccountListLayout = () => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const { data, isPending, error } = useListContext<Account>();
  

  return (
    <>
      <MobileListHeader
        title={translate("resources.accounts.name", { smart_count: 2 })}
        onCreateClick={() => redirect("create", "accounts")}
      />
      <MobileContent>
        {isPending ? (
          <div className="space-y-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-16 w-full rounded-xl" />
            ))}
          </div>
        ) : error ? (
          <p className="text-sm text-destructive">
            {translate("ra.message.error")}
          </p>
        ) : data?.length ? (
          <div className="space-y-3">
            {data.map((acc) => (
              <Card
                key={acc.id}
                className="py-3 cursor-pointer active:opacity-70"
                onClick={() => redirect("edit", "accounts", acc.id)}
              >
                <CardContent className="px-4 flex items-center justify-between">
                  <div>
                    <div className="font-semibold">{acc.name}</div>
                    <div className="text-xs text-muted-foreground">
                      {translate(`resources.accounts.types.${acc.type}`, {
                        _: acc.type,
                      })}
                    </div>
                  </div>
                  <AccountBalanceBadge accountId={acc.id} />
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <p className="py-16 text-center text-muted-foreground">
            {translate("resources.accounts.empty.title", { _: "Счетов нет" })}
          </p>
        )}
        <div className="flex justify-center mt-4">
          <InfinitePagination />
        </div>
      </MobileContent>
    </>
  );
};
